// removed by extract-text-webpack-plugin
module.exports = {"ticketsContainer":"_2doQN7bBE3q7zj6OvYTvfr"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/forms/TicketsForm.scss
// module id = 1531
// module chunks = 0